<template>
  <div id="cargo_ship">
    <div v-if="receivedData">
      <TabsCustomGraphic 
        :received-data="receivedData"
        id="cargo"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'CargoShip',
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'cargo_turnover',
      cloneElementId: 'cargo_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '39,40').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>